"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = CurrencyTable;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _currencyHelper = require("@eig-builder/core-utils/helpers/currency-helper");

var _numberHelper = require("@eig-builder/core-utils/helpers/number-helper");

var _isString = _interopRequireDefault(require("lodash/isString"));

var _TextField = _interopRequireDefault(require("@eig-builder/core-ui/TextField"));

var convertValueOnChange = function convertValueOnChange(value, currency) {
  return (0, _isString["default"])(value) && (0, _currencyHelper.simpleFormat)(value, currency);
};

function CurrencyTable(_ref) {
  var onBlur = _ref.onBlur,
      value = _ref.value,
      uniqueKey = _ref.uniqueKey,
      currency = _ref.currency;

  var formatedValue = function formatedValue(val) {
    return (0, _currencyHelper.formatCurrency)((0, _numberHelper.convertToFloat)(val), {
      code: currency
    });
  };

  var _useState = (0, _react.useState)(formatedValue(value)),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      localValue = _useState2[0],
      setLocalValue = _useState2[1];

  var handleChange = function handleChange(event) {
    setLocalValue(convertValueOnChange(event.target.value, currency));
  };

  var handleBlur = function handleBlur(event) {
    var val = event.target.value.replace('$', '');
    onBlur({
      target: {
        id: uniqueKey,
        value: (0, _numberHelper.convertToFloat)(val)
      }
    });
    setLocalValue(formatedValue(val));
  };

  return /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
    onBlur: handleBlur,
    id: uniqueKey,
    onChange: handleChange,
    value: localValue
  });
}

CurrencyTable.propTypes = {
  value: _propTypes["default"].any,
  currency: _propTypes["default"].string.isRequired,
  onBlur: _propTypes["default"].func.isRequired,
  uniqueKey: _propTypes["default"].string.isRequired
};